module.exports = "pegasus/assets/blocks/social-2-theme4.png";